"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bvt_1 = require("./bvt");
var xml_1 = require("./xml");
function loadTemplate(template, type) {
    if (type === "bvt") {
        return bvt_1.default.parse(template);
    }
    else {
        return xml_1.default.parse(template);
    }
}
exports.loadTemplate = loadTemplate;
//# sourceMappingURL=parse.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/template/parse.js
// module id = 886
// module chunks = 0 1